import axios from '@/api/config';

const liveRoom = {
  getLiveRoomById(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/getLiveRoom/` + data, {});
  },
  getLiveRoomDetail(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/getLiveRoomDetail`, {
      params: data
    });
  },
  getViewerStatistics(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/getViewerStatistics`, {
      params: data
    });
  },
  getLiveRoom(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/getLiveRoom`, {
      params: data
    });
  },
  getLiveRoomList(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/getLiveRoomList`, {
      params: data
    });
  },
  getLiveRoomTree(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/getLiveRoomTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/liveRoom/pageList`, data);
  },
  pagelistForRecord(data) {
    return axios.post(`${process.env.BASE_URL}/polyvChannel/pageListPolvy`, data);
  },
  addLiveRoom(data) {
    return axios.post(`${process.env.BASE_URL}/liveRoom/addLiveRoom`, data);
  },
  updateLiveRoom(data) {
    return axios.put(`${process.env.BASE_URL}/liveRoom/updateLiveRoom`, data);
  },
  deleteLiveRoom(data) {
    return axios.delete(`${process.env.BASE_URL}/liveRoom/deleteLiveRoom`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/liveRoom/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/liveRoom/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/liveRoom/active`, data);
  },
}

export default liveRoom;



// WEBPACK FOOTER //
// ./src/api/liveRoom.js